<template>
  <div>
    <table-render
      :schema.sync="schema"
      :rows="rows"
      :stickyHeader="`calc(100vh - 2.5rem)`"
      id="additional-charges-table"
      :tableClass="'with-scroll'"
    >
    </table-render>
  </div>
</template>

<script >
export default {
  props: ['rows'],
  data() {
    return {
      schema: []
    }
  },
  mounted() {
    this.setInitialData()
  },
  methods: {
    setInitialData() {
      this.schema = [
        {label: 'Tipo de cobro', key: 'additional_charges_attribute_name_translation'},
        {label: 'Valor', key: 'amount', class: ['text-right']},
        {label: 'Detalle', key: 'description', class: ['text-center']}
      ]
    }
  }
}
</script>